import { apiClient } from './apiClient';

/**
 * Analytics Service
 * Handles user analytics and dashboard statistics
 */

// API Response from backend
export interface DashboardAnalyticsResponse {
  views: number;           // Total views across all portfolio items
  portfolioItems: number;  // Count of portfolio items
  inquiries: number;       // TODO: Will be implemented when inquiries table exists
  followers: number;       // TODO: Will be implemented when followers table exists
}

export const analyticsService = {
  /**
   * Get dashboard analytics
   * GET /analytics
   */
  getDashboardStats: async () => {
    return await apiClient.get<DashboardAnalyticsResponse>('/analytics');
  },
};
